<template>
    <!-- Swiper -->
  <div class="swiper mySwiper">
    <div class="swiper-wrapper">
      <div class="swiper-slide" v-for="(item,index) in dataList" :key="index">
        <div :style="{ backgroundImage: `url(${item.Img})` }" class="img"  @click="imgClick(item)">
            </div>
      </div>
     
    </div>
  </div>


</template>

<script>
import { getnewList } from "../../api/resouces";

export default {
    data() {
        return {
            currentIndex: 0,
            dataList: [],
            autoplayInterval: null,
            titleTree: [],
            pid: '',
            classId: 43,
            chgID: 0,
            imgList: [
                {
                    url: "1"
                },
                {
                    url: "2"
                },
                {
                    url: "3"
                },
                {
                    url: "4"
                },
            ]
        };
    },
    computed: {
        currentLargeImage() {
            return this.dataList.length > 0 ? this.dataList[this.currentIndex].Img : '';
        },
        currentSmallImage() {
            return this.dataList.length > 0
                ? this.dataList[(this.currentIndex + 1) % this.dataList.length].Img
                : '';
        },
    },
    created() {
          this.titleTree = JSON.parse(sessionStorage.getItem('titleTree'))
          getnewList({ classId: 73 }).then((res) => {
            res.data.forEach((item) => {
              if (item.Img) {
                item.Img = item.Img.replace(/\/upload/g, `${this.$urlFile}/upload`);
                this.dataList.push(item);
              }
            });
            getnewList({ classId: 74 }).then((res) => {
            res.data.forEach((item) => {
              if (item.Img) {
                item.Img = item.Img.replace(/\/upload/g, `${this.$urlFile}/upload`);
                this.dataList.push(item);
              }
            });
            // // 确保在数据加载完成后启动自动播放
            // if (this.dataList.length > 0) {
            //   this.startAutoplay();
            // }
          });

          });

    },
    mounted() {
        var swiper = new Swiper(".mySwiper", {
      pagination: {
        el: ".swiper-pagination",
        dynamicBullets: true,
      },
      })
        setTimeout(() => {
        this.init()

        }, 1000);

    },
    methods: {
        init() {
            let next = document.getElementById("next")
            let prev = document.getElementById('prev')
            const rotatePic = document.querySelector('.rotate_pic')
            const swiperBox = document.querySelector('.swiper_box')
            const swiperDiv = document.querySelectorAll('.swiper_box div')
            swiperDiv[0].style.transform = `scale(1.2)`
            swiperDiv[0].style.transitionDuration = `1s`
            // function render(index) {
            //     for (let i = 0; i < index; i++) {
            //         rotatePic.innerHTML += `<img src="images/rotate_${i + 1}.png">`
            //     }
            // }
            // render(swiperDiv.length)

            this.chgID = 0

            // next.addEventListener('click', () => {
            //     this.chgID++
            //     this.chgID = this.chgID > swiperDiv.length - 1 ? swiperDiv.length - 1 : this.chgID
            //     this.btnCommon()
            // })
            // prev.addEventListener('click', () => {
            //     this.chgID--
            //     this.chgID = this.chgID < 0 ? 0 : this.chgID
            //     this.btnCommon()
            // })

        },
        next() {
            const swiperDiv = document.querySelectorAll('.swiper_box div')
            this.chgID++
            // if (this.chgID + 2 == this.imgList.length) {
            //     let obj = JSON.parse(JSON.stringify(this.imgList[0]))
            //     this.imgList.push(obj)
            // }
            // this.chgID = this.chgID > swiperDiv.length - 2 ? swiperDiv.length - 2 : this.chgID
            this.btnCommon()
        },
        prev() {
            const swiperDiv = document.querySelectorAll('.swiper_box div')
            this.chgID--
            // this.chgID = this.chgID < 0 ? 0 : this.chgID
            this.btnCommon()
        },
        btnCommon() {
            const next = document.querySelector('#next')  //后一个按钮
            const prev = document.querySelector('#prev')    //前一个按钮
            const rotatePic = document.querySelector('.rotate_pic')
            const swiperBox = document.querySelector('.swiper_box')
            const swiperDiv = document.querySelectorAll('.swiper_box div')
            console.log("document.querySelector('.swiper_box')", swiperDiv[0].style)
            // next.style.pointerEvents = this.chgID == swiperDiv.length - 2 ? 'none' : 'auto'   //在划到最后一张或者第一张是否失焦
            // prev.style.pointerEvents = this.chgID == 0 ? 'none' : 'auto'
            // next.style.opacity = this.chgID == swiperDiv.length - 2 ? .6 : 1    //在划到最后一张或者第一张是否透明
            // prev.style.opacity = this.chgID == 0 ? .6 : 1
            // rotatePic.style.transform = `rotate(-${this.chgID * 45}deg)`
            // swiperBox.style.transform = `translateX(-${this.chgID * 100 / swiperDiv.length}%)`
            rotatePic.style.transform = this.chgID > swiperDiv.length - 2?`rotate(0deg)`:this.chgID <0?`rotate(-${(swiperDiv.length - 2) * 45}deg)`:`rotate(-${this.chgID * 45}deg)`
            swiperBox.style.transform = this.chgID > swiperDiv.length - 2?`translateX(0%)`:this.chgID <0?`translateX(-${(swiperDiv.length - 2)*100/ swiperDiv.length}%)`:`translateX(-${this.chgID * 100 / swiperDiv.length}%)`
            this.chgID = this.chgID > swiperDiv.length - 2?0:this.chgID <0?this.chgID = swiperDiv.length - 2:this.chgID
            console.log("this.chgID",this.chgID)
            for (let i = 0; i < swiperDiv.length; i++) {
                if (i == this.chgID) {
                    swiperDiv[i].style.transform = `scale(1.2)`
                    swiperDiv[i].style.transitionDuration = `1s`
                } else {
                    swiperDiv[i].style.transform = `scale(1)`
                    swiperDiv[i].style.transitionDuration = `1s`

                }
            }
        },
        imgClick(obj) {
            console.log("obj",obj)
            this.titleTree.children.forEach((item, index) => {
                // console.log("item",item)
                if (item.children != null) {
                    item.children.forEach((item2, index2) => {
                        if (item2.data.id === obj.classId) {
                            this.pid = item2.data.columnPid
                        }
                    })
                }
            });
            this.$router.push({
                path: '/detail',
                query: {
                    pid: this.pid,
                    id: obj.classId,
                    detailId: obj.id,
                }
            })
        },
        nextImage() {
            this.currentIndex = (this.currentIndex + 1) % this.dataList.length;
            this.resetAutoplay(); // 重置计时器
        },
        prevImage() {
            this.currentIndex = (this.currentIndex - 1 + this.dataList.length) % this.dataList.length;
            this.resetAutoplay(); // 重置计时器
        },
        startAutoplay() {
            this.autoplayInterval = setInterval(() => {
                // if((this.chgID+2) == this.dataList.length){
                    this.next();
                // }
            }, 3000); // 自动播放间隔，单位毫秒
        },
        stopAutoplay() {
            clearInterval(this.autoplayInterval);
        },
        resetAutoplay() {
            this.stopAutoplay();
            this.startAutoplay();
        },

    },
    beforeDestroy() {
        this.stopAutoplay();
    },
    //图片点击跳转事件

};
</script>

<style scoped>
html,
    body {
      position: relative;
      height: 100%;
    }

    body {
      background: #eee;
      font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
      font-size: 14px;
      color: #000;
      margin: 0;
      padding: 0;
    }
.swiper {
      width: 100%;
      height: 100%;
      overflow: hidden;
    }

    .swiper-slide {
      text-align: center;
      font-size: 18px;
      background: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .swiper-slide img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .img{
        width: 100%;
        height: 100%;
        background-size: 100% 100%;
    }
    /* .swiper-pagination{
        width: 100%;
      height: 100%;
    } */
</style>



// WEBPACK FOOTER //
// src/components/carousel/swiper_publication.vue